import { SortButtonDirection } from "@/component"

import { OrderDirection } from "./types"

export const PER_PAGE = 20

export const sortDirectionIndexToStr = {
  [OrderDirection.ASC]: SortButtonDirection.Asc,
  [OrderDirection.DESC]: SortButtonDirection.Desc,
}

export const sortDirectionValueMap = {
  [SortButtonDirection.Asc]: OrderDirection.ASC,
  [SortButtonDirection.Desc]: OrderDirection.DESC,
}

// 默认排序为 orderedAt Desc
export const DEFAULT_SORT_SELECTED = "orderedAt"
export const DEFAULT_SORT_DIRECTION_SELECTED = SortButtonDirection.Desc

export const INIT_STATUS_CHOICES = [
  {
    "tran_key": "ShipmentStatus.Pending",
    "value": "Pending",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.InfoReceived",
    "value": "Info received",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.InTransit",
    "value": "In transit",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.OutForDelivery",
    "value": "Out for delivery",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.Delivered",
    "value": "Delivered",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.Exception",
    "value": "Exception",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.FailedAttempt",
    "value": "Failed attempt",
    "count": 0,
  },
  {
    "tran_key": "ShipmentStatus.Expired",
    "value": "Expired",
    "count": 0,
  },
]
